<template>
  <div class="product-showcase-page">
    <ProductShowcase 
      @buy-now="handleBuyNow"
      @learn-more="handleLearnMore"
      @product-selected="handleProductSelected"
    />
  </div>
</template>

<script>
import ProductShowcase from '../organisms/ProductShowcase.vue'

export default {
  name: 'ProductShowcasePage',
  
  components: {
    ProductShowcase
  },
  
  methods: {
    /**
     * Handles buy now action from product showcase
     * @param {Object} data - Product and color selection data
     */
    handleBuyNow(data) {
      console.log('Buy Now clicked:', data)
      // Implement buy now logic here
      // Could redirect to checkout or add to cart
    },
    
    /**
     * Handles learn more action from product showcase
     * @param {Object} product - Selected product data
     */
    handleLearnMore(product) {
      console.log('Learn More clicked:', product)
      // Implement learn more logic here
      // Could show product details modal or navigate to product page
    },
    
    /**
     * Handles product selection from grid
     * @param {Object} product - Selected product data
     */
    handleProductSelected(product) {
      console.log('Product selected:', product)
      // Implement product selection logic here
      // Could update URL or track analytics
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~/scss/include/_commonInclude.scss";

.content .app {
  .product-showcase-page {
    // Page-specific styles if needed
  }
}
</style>